// /* eslint-disable no-restricted-syntax */
// import React, { useState } from "react";
// import {
//   Form,
//   Input,
//   Button,
//   Checkbox,
//   Spin,
//   Row,
//   Col,
//   ConfigProvider,
//   message,
// } from "antd";
// import { Link } from "react-router-dom";
// import styled from "styled-components";
// import axios from "axios";
// import Cookies from "js-cookie";

// var CryptoJS = require("crypto-js");

// const Login = () => {
//   const [messageApi, contextHolder] = message.useMessage();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleLogin = () => {
//     if (!username) {
//       messageApi.error("Please enter your username!");
//       return;
//     }
//     if (!password) {
//       messageApi.error("Please enter your password!");
//       return;
//     }

//     setLoading(true);
//     axios
//       .post(
//         "https://bhugolapps.com/adminmodule/CustomLoginAPI",
//         {
//           username: username,
//           password: password,
//         },
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       )
//       .then((response) => {
//         const loginResponse = response.data;
//         setLoading(false);
//         if (loginResponse.status === "success" && response.status === 200) {
//           const encryptedToken = CryptoJS.AES.encrypt(
//             loginResponse.token,
//             "y9L@91nYW%BRfc1g"
//           ).toString();
//           // Save user details to cookies
//           Cookies.set("username", loginResponse.data.username, { expires: 1 }); // Expires in 1 day
//           Cookies.set("fullName", loginResponse.data.name || username, {
//             expires: 1,
//           });
//           Cookies.set("userGroup", loginResponse.data.user_group, {
//             expires: 1,
//           });
//           Cookies.set("id", loginResponse.data.id, { expires: 1 });
//           Cookies.set(
//             "primaryRequirement",
//             loginResponse.data.primaryRequirement || "",
//             { expires: 1 }
//           );
//           Cookies.set("district", loginResponse.data.district || "", {
//             expires: 1,
//           });
//           Cookies.set("token", encryptedToken, { expires: 1 });
//           Cookies.set("isHinduKhatikSamaj", true, { expires: 1 });

//           // Console log user details
//           console.log("User Details:", {
//             username: loginResponse.data.username,
//             fullName: loginResponse.data.name || username,
//             userGroup: loginResponse.data.user_group,
//             id: loginResponse.data.id,
//             primaryRequirement: loginResponse.data.primaryRequirement,
//             district: loginResponse.data.district || "",
//             token: loginResponse.token,
//             isHinduKhatikSamaj: true,
//           });

//           messageApi.success(`Logged in successfully! Welcome, ${username}`);
//           setTimeout(() => {
//             window.location.replace("/");
//           }, 2000);
//         } else {
//           messageApi.error(
//             loginResponse.message || "Login failed. Please try again."
//           );
//         }
//       })
//       .catch((error) => {
//         setLoading(false);
//         messageApi.error(
//           error.response?.data?.message ||
//             "Login failed due to a network or server error. Please try again."
//         );
//       });
//   };

//   return (
//     <ConfigProvider>
//       {contextHolder}
//       <Spin tip="Logging In..." size="large" spinning={loading}>
//         <Container>
//           <Row gutter={0} style={{ height: "100vh" }}>
//             <Col xs={24} md={12} style={{ background: "#0059ab" }}>
//               <LeftPanel>
//                 <LoginIcon>
//                   <svg
//                     width="200"
//                     height="200"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
//                       fill="#ffffff"
//                     />
//                   </svg>
//                 </LoginIcon>
//                 <LoginHeader>Welcome to HKS Portal</LoginHeader>
//               </LeftPanel>
//             </Col>
//             <Col xs={24} md={12}>
//               <RightPanel>
//                 <Form
//                   layout="vertical"
//                   style={{ width: "100%", maxWidth: "400px" }}
//                 >
//                   <FormHeader>HKS Login</FormHeader>
//                   <Form.Item
//                     label={
//                       <span className="text-base font-medium">Username</span>
//                     }
//                     name="username"
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please input your username!",
//                       },
//                     ]}
//                   >
//                     <Input
//                       className="p-3 rounded-md border-gray-300"
//                       placeholder="Enter your username"
//                       value={username}
//                       onChange={(e) => setUsername(e.target.value)}
//                     />
//                   </Form.Item>
//                   <Form.Item
//                     label={
//                       <span className="text-base font-medium">Password</span>
//                     }
//                     name="password"
//                     rules={[
//                       {
//                         required: true,
//                         message: "Please input your password!",
//                       },
//                     ]}
//                   >
//                     <Input.Password
//                       className="p-3 rounded-md border-gray-300"
//                       placeholder="Enter your password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                     />
//                   </Form.Item>
//                   <Form.Item name="remember" valuePropName="checked">
//                     <CheckboxContainer>
//                       <Checkbox>Remember me</Checkbox>
//                       <ForgotPasswordLink to="/forgot-password">
//                         Forgot Password?
//                       </ForgotPasswordLink>
//                     </CheckboxContainer>
//                   </Form.Item>
//                   <Form.Item>
//                     <SignInButton type="primary" onClick={handleLogin}>
//                       Sign In
//                     </SignInButton>
//                   </Form.Item>
//                   <RegisterLink>
//                     Don't have an account?{" "}
//                     <Link to="/register">Create an Account</Link>
//                   </RegisterLink>
//                 </Form>
//               </RightPanel>
//             </Col>
//           </Row>
//         </Container>
//       </Spin>
//     </ConfigProvider>
//   );
// };

// export default Login;

// const Container = styled.div`
//   min-height: 100vh;
//   background: #f0f2f5;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const LeftPanel = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   height: 100%;
//   padding: 40px;
// `;

// const RightPanel = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   height: 100%;
//   padding: 40px;
//   background: #ffffff;
// `;

// const LoginHeader = styled.h1`
//   font-size: 36px;
//   font-weight: 600;
//   color: #ffffff;
//   margin-top: 20px;
//   text-align: center;
// `;

// const FormHeader = styled.h2`
//   font-size: 28px;
//   font-weight: 600;
//   color: #1a1a1a;
//   margin-bottom: 24px;
//   text-align: center;
// `;

// const LoginIcon = styled.div`
//   svg {
//     width: 150px;
//     height: 150px;
//   }
// `;

// const SignInButton = styled(Button)`
//   width: 100%;
//   height: 48px;
//   border-radius: 8px;
//   background: #0059ab;
//   font-size: 16px;
//   font-weight: 500;
//   &:hover {
//     background: #004080;
//   }
// `;

// const CheckboxContainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;

// const ForgotPasswordLink = styled(Link)`
//   color: #0059ab;
//   font-size: 14px;
//   &:hover {
//     text-decoration: underline;
//   }
// `;

// const RegisterLink = styled.div`
//   text-align: center;
//   font-size: 14px;
//   color: #595959;
//   a {
//     color: #0059ab;
//     &:hover {
//       text-decoration: underline;
//     }
//   }
// `;
/* eslint-disable no-restricted-syntax */

import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Spin,
  Row,
  Col,
  ConfigProvider,
  message,
} from "antd";
import GhatikLogo3 from "../../Images/GhatikLogo3.png";
import MPBCDCLOGO from "../../Images/MPBCDCLOGO.png";
import GhatikCorp from "../../Images/GhatikCorp.png";
import { Link } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import Cookies from "js-cookie";

var CryptoJS = require("crypto-js");

const Login = ({onLogin}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = () => {
    if (!username) {
      messageApi.error("Please enter your username!");
      return;
    }
    if (!password) {
      messageApi.error("Please enter your password!");
      return;
    }

    setLoading(true);
    axios
      .post(
        "https://bhugolapps.com/adminmodule/CustomLoginAPI",
        {
          username: username,
          password: password,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((response) => {
        const loginResponse = response.data;
        setLoading(false);
        if (loginResponse.status === "success" && response.status === 200) {
          const encryptedToken = CryptoJS.AES.encrypt(
            loginResponse.token,
            "y9L@91nYW%BRfc1g"
          ).toString();
          Cookies.set("username", loginResponse.data.username, { expires: 1 });
          Cookies.set("fullName", loginResponse.data.name || username, { expires: 1 });
          Cookies.set("userGroup", loginResponse.data.user_group, { expires: 1 });
          Cookies.set("id", loginResponse.data.id, { expires: 1 });
          Cookies.set("primaryRequirement", loginResponse.data.primaryRequirement || "", { expires: 1 });
          Cookies.set("district", loginResponse.data.district || "", { expires: 1 });
          Cookies.set("token", encryptedToken, { expires: 1 });
          Cookies.set("isHinduKhatikSamaj", true, { expires: 1 });

          console.log("User Details:", {
            username: loginResponse.data.username,
            fullName: loginResponse.data.name || username,
            userGroup: loginResponse.data.user_group,
            id: loginResponse.data.id,
            primaryRequirement: loginResponse.data.primaryRequirement,
            district: loginResponse.data.district || "",
            token: loginResponse.token,
            isHinduKhatikSamaj: true,
          });

          messageApi.success(`Logged in successfully! Welcome, ${username}`);
          setTimeout(() => {
            window.location.replace("/");
          }, 2000);
        } else {
          messageApi.error(loginResponse.message || "Login failed. Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        messageApi.error(
          error.response?.data?.message ||
            "Login failed due to a network or server error. Please try again."
        );
      });
  };

  return (
    <ConfigProvider>
      {contextHolder}
      <Spin tip="Logging In..." size="large" spinning={loading}>
        <Container>
          <Row gutter={0} style={{ height: "100vh" ,width:"100%"}}>
            <Col xs={24} md={12} style={{ background: "#193367" }}>
              <LeftPanel  style={{ background: "#193367" }}>
                <LoginIcon>
                  <img src={GhatikLogo3} alt="HKS Logo" />
                </LoginIcon>
                <LoginHeader>Welcome!</LoginHeader>
              </LeftPanel>
            </Col>
            <Col xs={24} md={12}>
              {/* <RightPanel>
                <Form
                  layout="vertical"
                  style={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}
                >
                  <Form.Item
                    label={<span style={{ fontSize: "16px", fontWeight: "500" }}>Username *</span>}
                    name="username"
                    rules={[{ required: true, message: "Please input your username!" }]}
                  >
                    <Input
                      style={{ padding: "8px", borderRadius: "4px", borderColor: "#d9d9d9" }}
                      placeholder="Enter your username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ fontSize: "16px", fontWeight: "500" }}>Password *</span>}
                    name="password"
                    rules={[{ required: true, message: "Please input your password!" }]}
                  >
                    <Input.Password
                      style={{ padding: "8px", borderRadius: "4px", borderColor: "#d9d9d9" }}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item name="remember" valuePropName="checked">
                    <CheckboxContainer>
                      <Checkbox>Remember me</Checkbox>
                      <ForgotPasswordLink to="/forgot-password">
                        Forgot Password?
                      </ForgotPasswordLink>
                    </CheckboxContainer>
                  </Form.Item>
                  <Form.Item>
                    <SignInButton type="primary" onClick={handleLogin}>
                      Login
                    </SignInButton>
                  </Form.Item>
                  <RegisterLink>
                    Don't have an account? <Link to="/register">Create an Account</Link>
                  </RegisterLink>
                </Form>
              </RightPanel> */}
              <RightPanel>

                <LogoContainer>
                  <img src={GhatikCorp} alt="Left Logo" style={{ width: '280px',marginBottom:"0px", marginRight: '10px' }} />
                  {/* <div style={{ flex: 1, textAlign: 'center', color: '#1e40af', fontSize: '16px', fontWeight: '500' }}>
                    HINDU KHATIK SAMAJ ECONOMIC DEVELOPMENT CORPORATION<br />
                    Subsidiary of MPBCDC, Mumbai<br />
                    Social Justice & Special Assistance Govt of Maharashtra
                  </div> */}
                  <img src={MPBCDCLOGO} alt="Right Logo" style={{ width: '60px', marginLeft: '10px' }} />
                </LogoContainer>
                <LoginCard>
                <Form
                  layout="vertical"
                  style={{ width: '100%', maxWidth: '300px', margin: '0 auto',marginTop:"25px" }}
                >
                  <Form.Item
                    label={<span style={{ fontSize: '16px', fontWeight: '400' }}>Username </span>}
                    name="username"
                    rules={[{ required: true, message: 'Please input your username!' }]}
                  >
                    <Input
                      style={{ padding: '8px', borderRadius: '4px', borderColor: '#d9d9d9' }}
                      placeholder="Enter your username here"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ fontSize: '16px', fontWeight: '400' }}>Password </span>}
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                  >
                    <Input.Password
                      style={{ padding: '8px', borderRadius: '4px', borderColor: '#d9d9d9' }}
                      placeholder="Enter your password here"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Item>
                  <Form.Item name="remember" valuePropName="checked">
                  <CheckboxContainer>
                    <CustomCheckbox style={{ fontSize: '14px' }}>Remember Me</CustomCheckbox>
                    <ForgotPasswordLink to="/forgot-password">Forgot Password?</ForgotPasswordLink>
                  </CheckboxContainer>
                  </Form.Item>
                  <Form.Item>
                    <SignInButton type="primary" onClick={handleLogin}>LOGIN</SignInButton>
                  </Form.Item>
                  <RegisterLink>
                    Don't have an account? <Link to="/register">Create an account</Link>
                  </RegisterLink>
                </Form>
              </LoginCard>
            </RightPanel>
            </Col>
          </Row>
        </Container>
      </Spin>
    </ConfigProvider>
  );
};

export default Login;

const Container = styled.div`
  min-height: 100vh;
  width:100%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 40px;
  background: #0059ab;
`;

const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 40px;
  background: #ffffff;
`;

const LoginHeader = styled.h1`
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin-top: 20px;
  text-align: center;
`;

const LoginIcon = styled.div`
  img {
    width: 250px;
    height:250px;
  }
`;

const SignInButton = styled(Button)`
  width: 180px;
  height: 40px;
  border-radius: 20px;
  background: #193367;
  font-size: 16px;
  font-weight: 500;
  &:hover {
    background: #004080;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  color: #193367;
  

`;

const ForgotPasswordLink = styled(Link)`
  color: #6A6A6A;
  text-decoration: underline;
  font-size: 14px;
  &:hover {
    color:#0059ab;
  }
`;

const RegisterLink = styled.div`
  text-align: center;
  font-size: 14px;
  color: #969696;
  a {
    color: #193367;
    &:hover {
      text-decoration: underline;
    }
  }
`;  
const LoginCard = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  height: 450px;
`;
const CustomCheckbox = styled(Checkbox)`
  && .ant-checkbox-inner {
    border-color: #193367;
    color: #193367; 
     &:hover {
    background: #004080;
    color: #193367;
  }
    
  }

  && .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #193367;
    border-color: #193367;color: #193367;
     &:hover {
    background: #004080;
    color: #193367;
  }
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
  gap:20px;
  margin-right:30px;
  text-align: center;
`;